import { render, staticRenderFns } from "./ExistingPhoneNumberVerification.vue?vue&type=template&id=3ff132d9&"
import script from "./ExistingPhoneNumberVerification.vue?vue&type=script&lang=js&"
export * from "./ExistingPhoneNumberVerification.vue?vue&type=script&lang=js&"
import style0 from "./ExistingPhoneNumberVerification.vue?vue&type=style&index=0&id=3ff132d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports